module.exports = __webpack_public_path__ + "assets/img/Type E (45).10e616d2.jpg";